'use client';

import React from 'react';

export type BadgeVariant =
  | 'confirmed'
  | 'pending'
  | 'attended'
  | 'completed'
  | 'cancelled'
  | 'noshow'
  | 'primary'
  | 'default';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  withDot?: boolean;
}

export function Badge({
  children,
  className = '',
  variant = 'default',
  withDot = false,
  ...props
}: BadgeProps) {
  const variants = {
    confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200/80',
    pending: 'bg-amber-50 text-amber-700 border-amber-200/80',
    attended: 'bg-blue-50 text-blue-700 border-blue-200/80',
    completed: 'bg-teal-50 text-teal-800 border-teal-200/80',
    cancelled: 'bg-rose-50 text-rose-700 border-rose-200/80',
    noshow: 'bg-slate-100 text-slate-600 border-slate-200',
    primary: 'bg-[#F4F3FF] text-[#6255F5] border-[#ECEAFF]',
    default: 'bg-slate-50 text-slate-700 border-slate-200'
  };

  const dotColors = {
    confirmed: 'bg-emerald-500',
    pending: 'bg-amber-500',
    attended: 'bg-blue-500',
    completed: 'bg-teal-600',
    cancelled: 'bg-rose-500',
    noshow: 'bg-slate-400',
    primary: 'bg-[#6255F5]',
    default: 'bg-slate-400'
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border select-none
        ${variants[variant]}
        ${className}
      `}
      {...props}
    >
      {withDot && (
        <span
          className={`w-1.5 h-1.5 rounded-full shrink-0 ${dotColors[variant]}`}
          aria-hidden="true"
        />
      )}
      <span>{children}</span>
    </span>
  );
}
